import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PolicyService } from 'src/app/services/policy.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'upsc-is4ups-banner',
  templateUrl: './is4ups-banner.component.html',
  styleUrls: ['./is4ups-banner.component.scss']
})
export class Is4upsBannerComponent {

  showIS4UPSBanner: boolean = false;
    is4upsDaysLeft: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private policyService: PolicyService
  ) {
    /* if ( (this.router?.url == '/dashboard') || (this.router?.url == '/billing') || ( /^\/claims(\/.*)?$/.test(this.router?.url) ) || ( /^\/policies(\/.*)?$/.test(this.router?.url) ) ) {
      this.determineIS4UPSBannerDisplay();
      //this.showIS4UPSBanner = true;
    } else {
      this.showIS4UPSBanner = false;
    } */
  }

  ngOnInit() {
    if (!this.userService.isIS4UAcquisitionUser()
        ||!((this.router?.url == '/dashboard') || (this.router?.url == '/billing')
        || ( /^\/claims(\/.*)?$/.test(this.router?.url) ) || ( /^\/policies(\/.*)?$/.test(this.router?.url) ))) {
      this.showIS4UPSBanner = false;
    }
    else {
      let is4upsQuoteDetails = JSON.parse(sessionStorage.getItem('is4upsQuoteDetails'));
      if(is4upsQuoteDetails) {
        this.determineIS4UPSBannerDisplay();
      }
      else {
        let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
        this.policyService.retrieveIS4UPSInfo(policyDetails?.policyNumber).subscribe(
          res => {
            sessionStorage.setItem('is4upsQuoteDetails', JSON.stringify(res?.data));
            this.determineIS4UPSBannerDisplay();
          },
          err => this.showIS4UPSBanner = false
        );
      }
    }
  }

  determineIS4UPSBannerDisplay() {
    let conversionInfo = this.policyService.getIS4UPSQuoteDetails();
    if(conversionInfo?.newRate) {
      const createdDateTime = new Date(conversionInfo?.createdDateTime);
      const currentDate = new Date();
      const timeDifference = currentDate.getTime() - createdDateTime.getTime();
      const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
      const daysLeft = 30 - daysDifference;

      if (daysDifference < 30) { // quote is less than 30 days old
        this.showIS4UPSBanner = true;
        this.is4upsDaysLeft = daysLeft == 1 ? daysLeft + " day" : daysLeft + " days";
      } else {
        this.showIS4UPSBanner = false; // do not show banner is quote is more than 30 days old
      }
    }
    else {
      this.showIS4UPSBanner = false;
    }
  }

  closeIS4UPSBanner() {
    this.showIS4UPSBanner = false;
  }

  goToIS4UPS() {
    this.router.navigate(['/multicarrier']);
  }
}
